// material-ui
import { useTheme } from '@mui/material/styles';
import { getSiteBrand } from 'utils/environment';
import logo from 'assets/images/logo.png';
import logoDev from 'assets/images/logo-dev.png';
import logoTest from 'assets/images/logo-test.png';

const LOGO_BY_BRAND = { prod: logo, test: logoTest, dev: logoDev };

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img src={LOGO_BY_BRAND[getSiteBrand()]} alt="Logo Icon" width="129" height="129" style={{ objectFit: 'contain' }} />
  );
}
